import { flex, pb, Skeleton } from '@openeducation/oe-it-components';
import { styled } from '@openeducation/oe-it-themes';
import React, { useCallback } from 'react';
import { View } from 'react-native';

import { TestId } from '../../constants/test-id';

const PCFeedbackRubricsLoader = () => {
  const renderColumn = useCallback((isLast?: boolean) => {
    return (
      <Column isLast={isLast} testID={TestId.PC_FEEDBACK_RUBRICS_LOADER}>
        <View style={[pb(24)]}>
          <Skeleton height={24} />
        </View>
        {Array.from({ length: 4 }).map((_, index) => (
          <Item key={index}>
            <Skeleton width={100} height={24} />
            <Circle size={24} />
          </Item>
        ))}
        <View />
      </Column>
    );
  }, []);

  return (
    <View style={[flex('flex-row')]}>
      {renderColumn()}
      {renderColumn()}
      {renderColumn(true)}
    </View>
  );
};

type ColumnType = {
  isLast?: boolean;
};

const Column = styled.View<ColumnType>`
  flex: 1;
  border-right-width: ${({ isLast }) => (isLast ? 0 : 1)}px;
  border-right-color: ${({ theme }) => theme.color.border};
  padding-right: ${({ isLast }) => (isLast ? 0 : 16)}px;
  margin-right: ${({ isLast }) => (isLast ? 0 : 16)}px;
  padding-top: 16px;
`;

const Item = styled.View`
  border-width: 1px;
  border-color: ${({ theme }) => theme.color.border};
  border-radius: 14px;
  padding: 16px;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
`;

type CircleType = {
  size: number;
};

const Circle = styled.View<CircleType>`
  width: ${({ size }) => size}px;
  height: ${({ size }) => size}px;
  border-radius: ${({ size }) => size / 2}px;
  background-color: ${({ theme }) => theme.color.light1};
  justify-content: center;
  align-items: center;
  margin-left: 8px;
`;

export { PCFeedbackRubricsLoader };
